
export interface TableRow{
  [key:string]:any;
}

export interface CsvParserOptions {
  headerRows?:number;
  columns?: string[];
}

function csvLineToArray(text:string):string[] {
  let ret = [''], i = 0, p = '', s = true;
  for (let j =0;j<text.length;j++) {
      let l = text[j];
      if ('"' === l) {
          s = !s;
          if ('"' === p) {
              ret[i] += '"';
              l = '-';
          } else if ('' === p)
              l = '-';
      } else if (s && ',' === l)
          l = ret[++i] = '';
      else
          ret[i] += l;
      p = l;
  }
  return ret;
}

export function parseCSV(txt:string,options?:CsvParserOptions):TableRow[]{
  const lines = txt.split('\n');
  const headerLength = options?.headerRows || (options?.columns ? 0 : 1);
  const headerLines = lines.slice(0,headerLength);
  const bodyLines = lines.slice(headerLength);

  let columns = options?.columns;
  if(!columns){
    const header = headerLines[0];
    columns = csvLineToArray(header);
  }

  return bodyLines.filter(ln=>ln.length).map(ln=>{
    let data = csvLineToArray(ln);

    let result:TableRow = {};
    data.forEach((val,i)=>{
      result[columns[i]] = parseVal(val);
    });
    return result;
  });
}

export function parseAttributedCSV(txt:string,options?:CsvParserOptions):{attributes:any, data:TableRow[]} {
  const lines = txt.split('\n');
  const lineHeaderEnds = lines.findIndex(ln=>ln.match(/^-+\s*$/));
  const headerLines = lines.slice(0,lineHeaderEnds);
  const bodyLines = lines.slice(lineHeaderEnds+1);

  const attributes:any = {};
  headerLines.forEach(ln=>{
    const kv = ln.split(',');
    if(kv.length>1){
      attributes[kv[0].trim()] = parseVal(kv.slice(1).join(',').trim());
    }
  });

  const data = parseCSV(bodyLines.join('\n'),options);

  return {
    attributes,
    data
  };
}

function parseVal(val:string):any{

  // Try date...
  const date = tryParseDate(val);
  if(date){
    return date;
  }

  if(val===''){
    return val;
  }

  // Try numeric
  let numeric:number = +val;
  if(!isNaN(numeric)){
    return numeric;
  }

  return val;
}

function tryParseDate(val:string):Date {
  let components = val.split('-');
  if(components.length===3){
    let dateComponents = components.map(c=>+c);
    if(isNaN(dateComponents[2])){
      const dateTimeComponents = components[2].split(' ');
      dateComponents[2] = +dateTimeComponents[0];
      if(dateTimeComponents.length>1){
        const timeComponents = dateTimeComponents[1].split(':');
        if(timeComponents.length===3){
          dateComponents.push(+timeComponents[0],+timeComponents[1],+timeComponents[2]);
        }
      }
    }

    if(!dateComponents.some(isNaN)){
      return new Date(Date.UTC(dateComponents[0],dateComponents[1]-1,dateComponents[2],dateComponents[3]||0,dateComponents[4]||0,dateComponents[5]||0));
    }
  }
  return null;
}